// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__OtxQp","truncatedText":"styles_truncatedText__y8DGD","fullText":"styles_fullText__oh5i_","textContainer":"styles_textContainer__LNzS8"};